<fuse-card class="flex w-full ">
  <div class="fles w-full list-table">
    <mat-tab-group animationDuration="0ms" (selectedTabChange)="onTabChange($event)">
      <mat-tab label="Holidays List">
        <div class="row p-5">
          <div class="col-md-6 col-6">
            @if (!addButton) {
              <div class="mt-2 text-2xl sm:text-4xl font-extrabold tracking-tight leading-tight">
                Holidays List
              </div>
            }
          </div>
          <div class="col-md-6 col-6 flex justify-end ">
            @if (addButton) {
              <app-select class="clientSelect" name="clientName" [required]="false" [isWhole]="true"
                labelKey="clientCompanyName" placeholder="Client Search" valueKey="id" [group]="clientSearch"
              [clearable]="true" [options]="client" (selectionChange)="onclientId($event)"> </app-select>
              <button mat-flat-button class=" add-button ml-4" (click)="addNewNote()">
                Add Holidays
              </button>
            }
          </div>
        </div>
        <div class="row p-0 mt-5">
          <app-table (editClick)="editRoute($event)" [showEditIcon]="true" [length]="totalRecordCount"
            [dataSource]="holidaysList" (page)="pageNo($event)" [columns]="employeeTableFields">
          </app-table>
        </div>
      </mat-tab>

      @if (addButton) {
        <mat-tab label="Client Weekends List">
          <div class="row p-5">
            <div class="col-md-12 flex justify-end">
              <button mat-flat-button class=" client-button ml-4" (click)="addClientHoliday()">
                Add Client Weekends
              </button>
            </div>
          </div>
          <div class="row p-0 mt-5">
            <app-table (editClick)="onOpenPopups($event)" [showEditIcon]="true" [dataSource]="clientNameAndWeekendList"
              [columns]="clientFields" (page)="pageNumbers($event)" [length]="totalCount">
            </app-table>
          </div>
        </mat-tab>
      }
    </mat-tab-group>
  </div>
</fuse-card>

<div class="modal" tabindex="1" role="dialog" [ngStyle]="{'display':addHolidays}">
  <div class="main-div">
    <fuse-card class="flex flex-col  md:w-160 md:min-w-160">
      <div class="row flex grow p-5">
        <form class="space-y-3" #supportNgForm="ngForm" [formGroup]="holidayForm">
          <div class="row mt-3">
            <div class="text-2xl font-bold tracking-tight">{{ updateButton ? 'Edit Holiday' : 'Add Holiday' }}</div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <app-select type="text" label="Client Name" name="clientName" [group]="holidayForm" [options]="client"
              labelKey="clientCompanyName" [required]="true" (selectionChange)="clientChangeId($event)"></app-select>
            </div>
            <div class="col-md-6">
              <app-input type="text" label="Holiday Name" [required]="true" name="holiday" [group]="holidayForm">
              </app-input>
            </div>
            <div class="col-md-6">
              <app-date-picker [required]="true" type="date" label="Holiday Date" [group]=" holidayForm"
                name="selectdate" [placeholder]="updateButton ? holidayDate : ''"
                (dateChange)="onFromDateChange($event)">
              </app-date-picker>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6"></div>
            <div class="col-md-6">
              <div class="flex items-center justify-end">
                <button mat-button [color]="'accent'" (click)="clearForm()">
                  Cancel
                </button>
                <button class="ml-2" mat-flat-button [color]="'primary'" [disabled]="holidayForm.invalid"
                  (click)="updateButton ? updateLeaveType() : sendForm()">
                  {{ updateButton ? 'Update' : 'Save' }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </fuse-card>
  </div>
</div>

<!-- Client Weekends Modal -->
<div class="modal" tabindex="1" role="dialog" [ngStyle]="{'display':addClientHolidays}">
  <div class="main-div">
    <fuse-card class="flex flex-col  md:w-160 md:min-w-160">
      <div class="row flex grow p-5">
        <form class="space-y-3" #supportNgForm="ngForm" [formGroup]="clientHolidayForm">
          <div class="row mt-3">
            <div class="text-2xl font-bold tracking-tight">{{ updateButton ? 'Update Client Weekends' : 'Add Client
            Weekends' }}</div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <app-select type="text" label="Client Name" name="clientName" [group]="clientHolidayForm"
              [options]="client" labelKey="clientCompanyName" [required]="true"></app-select>
            </div>
            <div class="col-md-6">
              <app-select type="text" label="Weekends" name="weekends" [group]="clientHolidayForm"
              [options]="MasterWeekend" labelKey="weekend" [required]="true"></app-select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6"></div>
            <div class="col-md-6">
              <div class="flex items-center justify-end">
                <button mat-button [color]="'accent'" (click)="clearForm()">
                  Cancel
                </button>
                <button class="ml-2" mat-flat-button [color]="'primary'" (click)="clientWeekendSave()">
                  {{ updateButton ? 'Update' : 'Save' }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </fuse-card>
  </div>
</div>